import store from '../store/apply_basic'

// 下步处理为导入文件
function canDealWith (flowId) {
  let stepId = store.state.makeCardFlow[flowId]
  return store.state.dealWithStepId.indexOf(stepId) > -1
}

// 下步处理为导出文件
function canExport (flowId) {
  let stepId = store.state.makeCardFlow[flowId]
  return store.state.exportStepId.indexOf(stepId) > -1
}

// 下步处理为审批
function canApprove (flowId) {
  let stepId = store.state.makeCardFlow[flowId]
  return stepId === '2'
}

// 下步处理为开卡
function canGenerateCard (flowId) {
  let stepId = store.state.makeCardFlow[flowId]
  return stepId === '4'
}

function showNextFlowName (flowId) {
  let stepId = store.state.makeCardFlow[flowId]
  return store.state.makeCardStep[stepId]
}

function showExportName (flowId) {
  let stepId = store.state.makeCardFlow[flowId]
  if (stepId === '7' || stepId === '8') {
    return showNextFlowName(flowId)
  }
}

function showFileHead (flowId = '1', type = null) {
  let stepId = store.state.makeCardFlow[flowId]
  switch (stepId) {
    case '5':
      return type ? 0 : store.state.cardInfoFileHead
    case '6':
    case '9':
    case '10':
      return type ? 1 : store.state.cardNumberFileHead
    case '3':
    default:
      return type ? 2 : store.state.customInfoFileHead
  }
}

function hasCardNumber (flowid = '1') {
  let stepId = store.state.makeCardFlow[flowid]
  switch (stepId) {
    case '5':
    case '6':
    case '9':
    case '10':
      return true
    default:
      return false
  }
}

export {
  canDealWith,
  canExport,
  canApprove,
  canGenerateCard,
  showNextFlowName,
  showExportName,
  showFileHead,
  hasCardNumber
}



// WEBPACK FOOTER //
// ./src/util/applyBase_handleCardTask.js